import { getStorageItem } from "../../helpers/storageManager"

let genericMessageList = window?.app_data?.appcmsMain?.genericMessages
let subscriptionBadges = {
    "buy": genericMessageList?.buy,
    "rent": genericMessageList?.rent,
    "svod": genericMessageList?.svod,
    "svod_buy": genericMessageList?.svodBuy,
    "svod_rent": genericMessageList?.svodRent,
    "svod_purchase": genericMessageList?.svodPurchase,
    "purchase" : genericMessageList?.purchase
}
const getBadgeText = async (monetizationBadgeIdentifier, plans, contentId) => {
    let store = getStorageItem('AuthenticationStore')
    let user = store?.user
    if (user) {
        let isPlanAvailable = handlePlansCheck(user, plans)
        let isTvodUser = await handleTvodPlans(contentId)
        if (isPlanAvailable || isTvodUser) return false
        return subscriptionBadges[monetizationBadgeIdentifier]
    } else {
        return subscriptionBadges[monetizationBadgeIdentifier]
    }
}
export const handlePlansCheck = (user,plans) => {
    let planGroupList = JSON.parse(localStorage.getItem("planGroupList"))
    let monetisationPlans = plans?.length ? plans?.filter((content) => content?.type === "SVOD") : []
    let monetisationPlansIds = monetisationPlans.map((plan) => plan?.planIds)
    let monetisationGroupIds = monetisationPlans.map((plan) => plan?.planGroupIds)
    monetisationGroupIds?.forEach((groupId) => {
        if(groupId) {
            monetisationPlansIds.push(planGroupList[groupId])
        }
    })
    let userPlanId = user?.subscription?.subscriptionInfo?.planId
    let subscriptionStatus = user?.subscription?.subscriptionInfo?.subscriptionStatus
    if (user?.isVip) {
        return true
    }
    if (monetisationPlansIds?.length) {
        if (user?.isSubscribed) {
        let isSvodPlanSubscribed = false
          monetisationPlansIds?.filter((plan) => {
            if (plan?.includes("svodAll")) {
                isSvodPlanSubscribed = true
            }
            })
          if (isSvodPlanSubscribed) return isSvodPlanSubscribed
        }
        let isPlanSubscribed =  false
        monetisationPlansIds?.filter((plan) => {
            if (plan?.includes(userPlanId) && ((subscriptionStatus === 'COMPLETED') || (subscriptionStatus === "DEFERRED_CANCELLATION"))) {
                isPlanSubscribed = true
            }
            })
        return isPlanSubscribed
    }else {
        return false
    }
  }

  export const handleTVEPlansCheck = (user,plans) => { 
    let planGroupList = JSON.parse(localStorage.getItem("planGroupList"))
    let monetisationPlans = plans?.length ? plans?.filter((content) => content?.type === "TVE" || content?.monetizationModel === "TVE") : []
    let monetisationPlansIds = monetisationPlans.map((plan) => plan?.planIds || [plan?.id])
    let monetisationGroupIds = monetisationPlans.map((plan) => plan?.planGroupIds)
        monetisationPlansIds?.length && monetisationPlansIds?.forEach((planIds) => {
          if (planIds?.length) monetisationPlansIds = [...planIds.flat()]
        })
        monetisationGroupIds?.length && monetisationGroupIds?.forEach((groupIds) => {
            if(groupIds?.length) {
                let plans = groupIds.map((groupId) => planGroupList[groupId])
                plans?.length && monetisationPlansIds.push(...plans.flat())
            }
        })
    let userPlanId = user?.subscription?.tveSubscriptions ?  user?.subscription?.tveSubscriptions?.map((plan) => plan?.planId) : [user?.tveMetadata?.planId]
    if (monetisationPlansIds?.length) {
        if (user?.isVip) {
            return true
        }
        if (user?.isSubscribed) {
        let isTvePlanSubscribed = false
          monetisationPlansIds?.filter((plan) => {
            if (plan?.includes("tveAll")) {
                isTvePlanSubscribed = true
            }
            })
          if (isTvePlanSubscribed) return isTvePlanSubscribed
        }
        let isPlanSubscribed =  false
        const monetisationPlansSet = new Set(monetisationPlansIds);
        const hasMatchingPlan = userPlanId?.some(plan => monetisationPlansSet.has(plan));
        isPlanSubscribed = hasMatchingPlan
        return isPlanSubscribed
    }else {
        // console.log("no tve plans present on episode")
        return false
    }
  }
const handleTvodPlans = async (contentId) => {
    let transactionList = getStorageItem('transactionUserList')
    let transactionUserList = transactionList?.transactionUserList
    let isTvodUser = false
    var lookup = {};

    for (var j in transactionUserList) {
        lookup[transactionUserList[j]] = transactionUserList[j];
    }
        if (transactionUserList?.length) {
                if (typeof lookup[contentId] != 'undefined') {
                    isTvodUser = true
                }
        }
    return isTvodUser
}

export { getBadgeText }